import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { CreateTruckPostMutation, EditTruck, GetTruckByID } from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import Button from "../../Button/Button";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast, WarningToast } from "../../ToastComponent/RectHotToast";
import CityState from "../AddVendorAccount/UserPreferenceAndVehicleCategory/CityState";
import { useModalContext } from "../../Reactportal/ModalContext";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";

const AddTMSTruckPost = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const Form_Key = "TMS_Truck_Post";
  const Truk_Details_Modal = "Truk_Details_Modal";
  const formRef = useRef({});
  const { pushModal, popModal } = useModalContext();
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [FormData, setFormdata] = useState({});
  const [toggle, settoggle] = useState(show ? show : false);
  const [openModal, setModal] = useState(false);
  const [googleSearchValue, setGoogleSearch] = useState("");
  const [selectedToCities, setSelectedToCities] = useState([]);
  const ReduxData = useSelector((store) => store.UniqueTableReducer);
  const fielddata = ReduxData?.TMS_Truck_Post?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [UnLoadingPostData, setUnLoadingPostData] = useState([]);
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [formErrors, setFormErrors] = useState({});
  const dispatch = useDispatch();
  const [initialData,setInitialData]=useState({})
  const {isDisabled}=useIsDisabled({TypeOfPortal,initial:initialData, current:FormData});

  //Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [CreatingData, { loading: CreateTruckPostLoading }] = useMutation(CreateTruckPostMutation, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [geTruckById, { loading: geTruckByIdLoader }] = useLazyQuery(GetTruckByID, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [EditingData, { loading: EditTruckLoading }] = useMutation(EditTruck, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const MenuMasterLoadingState = CreateTruckPostLoading || EditTruckLoading || geTruckByIdLoader;

  const HanldeChangeonForm = (values) => {
    setFormdata(prev=>{
      const next = {...prev,...values};
      if(!isFirstLoad){
        setInitialData(next)
      }
      return next
    })
  };

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  useEffect(() => {
    if (TypeOfPortal !== "Add" && fielddata) {
      getFormSectionAndFields().then(() => {
        geTruckById({
          variables: {
            id: fielddata._id,
          },
        }).then(({ data }) => {
          let TruckData = data?.getTruckByIdWithPopulate || {};
          let {
            Unloading_Points,
            Loading_Address_Line_1,
            Loading_City,
            Loading_Landmark,
            Loading_Latitude,
            Loading_Longitude,
            Loading_Name,
            Loading_Pincode,
            Loading_State,
          } = TruckData;

          let Veh = TruckData?.Vehicle_No_ID || {};
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Account_ID: TruckData?.Account_ID,
                From_Location: {
                  formattedAddress: Loading_Address_Line_1,
                  city: Loading_City,
                  locality: Loading_Landmark,
                  latitude: Loading_Latitude,
                  longitude: Loading_Longitude,
                  name: Loading_Name,
                  pincode: Loading_Pincode,
                  state: Loading_State,
                },
                Vehicle_No: { ...Veh, Search_Value: Veh?.Vehicle_No },
              },
            },
          });
          TruckData = {
            ...TruckData,
            Account_ID: TruckData?.Account_ID?.Business_Name,
            Vehicle_No: TruckData?.Vehicle_No_ID?.Vehicle_No,
          };

          setAllFieldsData(TruckData);

          let updatedData = Unloading_Points?.map((el) => {
            let obj = {
              Type: el?.Unloading_Type || "",
              Location: el?.Unloading_City || "",
              Latitude: "",
              Longitude: "",
              State: "",
            };
            if (obj.Type === "City") {
              obj = {
                ...obj,
                Latitude: el?.Unloading_Latitude || "",
                Longitude: el?.Unloading_Longitude || "",
                State: el?.Unloading_State || "",
              };
            }
            return obj;
          });
          setGoogleSearch(TruckData.Loading_Name);
          setSelectedToCities(updatedData);
          updateValueForm(formRef, TruckData);
        });
      });
    } else {
      const values = {
        Loading_Search_Radius: 75,
        Unloading_Search_Radius: 200,
        Post_Duration: 48,
      };
      setAllFieldsData(values);
      updateValueForm(formRef, values);
    }
  }, [fielddata]);

  useEffect(() => {
    let UnLoadingData = selectedToCities?.map((e) => {
      if (e.Type === "City") {
        return {
          Unloading_City: e.Location,
          Unloading_Name: e.Location,
          Unloading_Longitude: e.Longitude,
          Unloading_Latitude: e.Latitude,
          Unloading_State: e.State,
          Unloading_Type: "City",
        };
      } else {
        return {
          Unloading_City: e.Location,
          Unloading_Name: e.Location,
          Unloading_Longitude: null,
          Unloading_Latitude: null,
          Unloading_State: e.Location,
          Unloading_Type: "State",
        };
      }
    });
    setUnLoadingPostData(UnLoadingData);
  }, [selectedToCities]);

  useEffect(() => {
    setSelectedRows(ReduxData?.TMS_Truck_Post?.Selected_Rows);
  }, [ReduxData]);

  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, FormData, selectedRows);
  const mutationFunctions = {
    CreatingData,
    EditingData,
  };

  const submit = (closeAction) => {
    FormData.Vehicle_No_ID = FormDataFromRedux?.MasterData[Form_Key]?.Vehicle_No?._id;
    FormData.Vehicle_No = FormDataFromRedux?.MasterData[Form_Key]?.Vehicle_No?.Search_Value;
    if (!UnLoadingPostData?.length || !FormDataFromRedux?.MasterData[Form_Key]?.From_Location?.city) {
      WarningToast("Select From and To Places Properly");
      return;
    }
    FormData.Loading_Address_Line_1 = FormDataFromRedux?.MasterData[Form_Key]?.From_Location.formattedAddress;
    FormData.Loading_City = FormDataFromRedux?.MasterData[Form_Key]?.From_Location.city;
    FormData.Loading_Landmark = FormDataFromRedux?.MasterData[Form_Key]?.From_Location.locality;
    FormData.Loading_Latitude = FormDataFromRedux?.MasterData[Form_Key]?.From_Location.latitude;
    FormData.Loading_Longitude = FormDataFromRedux?.MasterData[Form_Key]?.From_Location.longitude;
    FormData.Loading_Name = FormDataFromRedux?.MasterData[Form_Key]?.From_Location.name;
    FormData.Loading_Pincode = FormDataFromRedux?.MasterData[Form_Key]?.From_Location.pincode;
    FormData.Loading_State = FormDataFromRedux?.MasterData[Form_Key]?.From_Location.state;
    FormData.Unloading_Points = UnLoadingPostData;

    const mutationFunction = getMutationFunction(operationType, mutationFunctions);
    const executeOperationFunction = () => {
      console.log(variables);
      return executeOperation({
        operationType,
        data: FormData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
      });
    };
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => handleFormReset(formRef),
      onSuccess: () => {},
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const clearFunction = () => {
    setSelectedToCities([]);
    setGoogleSearch("");
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    ClearSpecificForm(dispatch, Form_Key);
    clearFunction();
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const CloseformfunctionforSecondModal = () => {
    setModal(false);
    popModal(Truk_Details_Modal);
  };

  const FooterContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={isDisabled}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      SaveAndClose={() => {
        TypeOfPortal === "Add" ? Validate_handleSubmit(SaveAndCloseForAdd) : Validate_handleSubmit(submit);
      }}
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={MenuMasterLoadingState}
    />
  );

  return (
    <div>
      <Reactportal
        FoooterContent={FooterContent}
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={"Truck"}
        TypeOfId={"Account Id :"}
        id={""}
      >
        {MenuMasterLoadingState && <div className="loader-line-div" />}
        <div className={"form-container-truck"}>
          {inputFields?.length > 0 ? (
            inputFields.map((el) => (
              <div key={el.id} className="form-componend">
                <FormInputSectionComponent
                  TypeOfPortal={TypeOfPortal}
                  inputfields={el.fields}
                  onErrorsChange={handleErrorsChange}
                  Type={el.name}
                  formkey={Form_Key}
                  onhandleFormikChange={HanldeChangeonForm}
                  formRef={formRef}
                  setFirstLoad={setFirstLoad}
                />
                <br />
                <Button
                  action={() => {
                    setModal(true);
                    pushModal(Truk_Details_Modal);
                  }}
                  name="modalbutton"
                  text="Lane"
                />
              </div>
            ))
          ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
            <p style={{ textAlign: "center" }}>No form fields available.</p>
          ) : null}
        </div>
      </Reactportal>
      {openModal && (
        <div className="form-container-truck">
          <Reactportal
            open={openModal}
            onClose={CloseformfunctionforSecondModal}
            TypeOfPortal={"Truck"}
            TypeOfId={"Account Id :"}
            id={""}
          >
            <div className="formContainer">
              <div className="LocationContainer">
                <div className="CityStateContainer">
                  <CityState
                    options={["Place Search"]}
                    title="From"
                    selectedData={selectedToCities}
                    setSelectedData={setSelectedToCities}
                    googleSearchValue={googleSearchValue}
                    setGoogleSearch={setGoogleSearch}
                    formkey={Form_Key}
                  />
                </div>
                <div className="CityStateContainer">
                  <CityState
                    options={["State", "City"]}
                    title="To"
                    selectedData={selectedToCities}
                    setSelectedData={setSelectedToCities}
                    googleSearchValue=""
                    setGoogleSearch={() => {}}
                    formkey={Form_Key}
                  />
                </div>
                <div className="CityStateContainerPreview">
                  <p className="headings" style={{ margin: "2px" }}>
                    {selectedToCities?.map((e, i) => {
                      return (
                        <div key={i} className="CityStateBoxPreview">
                          <p className="lightheading">{e.Type}</p>
                          <p className="CityStateName">{e.Location}</p>
                        </div>
                      );
                    })}
                  </p>
                </div>
              </div>
            </div>
            <PortalFooter
              renderContent={() => <></>}
              disabled={false}
              submitform={""}
              submitType={""}
              SaveAndClose={""}
              Form_key={Form_Key}
              TypeOfPortal={TypeOfPortal}
              handleformclose={() => {
                CloseformfunctionforSecondModal();
                setModal(false);
              }}
              loadingState={MenuMasterLoadingState}
              Cancletype="OK"
            />
          </Reactportal>
        </div>
      )}
    </div>
  );
};

export default AddTMSTruckPost;
